import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { X } from 'lucide-react';
export function Footer() {
  const currentYear = new Date().getFullYear();
  const [activeModal, setActiveModal] = useState<'privacy' | 'terms' | null>(null);
  const closeModal = () => setActiveModal(null);
  return <>
      <footer className="bg-brand-black py-12 border-t border-brand-gold/20 relative" data-id="element-18">
        <div className="max-w-6xl mx-auto px-4 flex flex-col items-center text-center" data-id="element-19">
          <h2 className="font-heading text-2xl font-bold text-white mb-2 tracking-widest" data-id="element-20">
            AS <span className="text-brand-gold" data-id="element-21">IMPULSO</span> DIGITAL
          </h2>

          <p className="text-gray-400 mb-8 tracking-wide" data-id="element-22">
            Basados en Chicago, IL
          </p>

          <div className="w-full h-[1px] bg-gradient-to-r from-transparent via-brand-charcoal-light to-transparent mb-8" data-id="element-23"></div>

          <div className="flex items-center justify-center mb-6" data-id="element-24">
            <button onClick={() => setActiveModal('privacy')} className="text-gray-500 hover:text-brand-gold transition-colors text-sm cursor-pointer" data-id="element-25">
              Política de Privacidad
            </button>
            <span className="text-brand-gold/30 mx-3" data-id="element-26">|</span>
            <button onClick={() => setActiveModal('terms')} className="text-gray-500 hover:text-brand-gold transition-colors text-sm cursor-pointer" data-id="element-27">
              Términos de Servicio
            </button>
          </div>

          <p className="text-gray-600 text-sm" data-id="element-28">
            &copy; {currentYear} AS Impulso Digital. Todos los derechos
            reservados.
          </p>
        </div>
      </footer>

      <AnimatePresence data-id="element-29">
        {activeModal && <div className="fixed inset-0 z-50 flex items-center justify-center p-4" data-id="element-30">
            {/* Backdrop */}
            <motion.div initial={{
          opacity: 0
        }} animate={{
          opacity: 1
        }} exit={{
          opacity: 0
        }} onClick={closeModal} className="fixed inset-0 bg-black/80 backdrop-blur-sm cursor-pointer" data-id="element-31" />

            {/* Modal Card */}
            <motion.div initial={{
          opacity: 0,
          scale: 0.95
        }} animate={{
          opacity: 1,
          scale: 1
        }} exit={{
          opacity: 0,
          scale: 0.95
        }} className="bg-brand-charcoal rounded-2xl border border-white/10 max-w-2xl w-full max-h-[80vh] overflow-hidden flex flex-col relative z-10" data-id="element-32">
              {/* Modal Header */}
              <div className="flex items-center justify-between p-6 border-b border-white/10" data-id="element-33">
                <h2 className="font-heading text-xl font-bold text-white" data-id="element-34">
                  {activeModal === 'privacy' ? 'Política de Privacidad' : 'Términos de Servicio'}
                </h2>
                <button onClick={closeModal} className="text-gray-400 hover:text-white transition-colors" aria-label="Cerrar" data-id="element-35">
                  <X className="w-6 h-6" data-id="element-36" />
                </button>
              </div>

              {/* Modal Body */}
              <div className="p-6 overflow-y-auto text-gray-300 text-sm leading-relaxed space-y-6" data-id="element-37">
                {activeModal === 'privacy' ? <>
                    <section data-id="element-38">
                      <h3 className="text-white font-bold mb-2" data-id="element-39">
                        Información que Recopilamos
                      </h3>
                      <p data-id="element-40">
                        Recopilamos información básica como nombre, correo
                        electrónico y número de teléfono cuando nos contactas a
                        través de nuestro sitio web o WhatsApp.
                      </p>
                    </section>
                    <section data-id="element-41">
                      <h3 className="text-white font-bold mb-2" data-id="element-42">
                        Uso de la Información
                      </h3>
                      <p data-id="element-43">
                        Utilizamos tu información únicamente para proporcionarte
                        nuestros servicios de diseño web, comunicarnos contigo
                        sobre tu proyecto y mejorar nuestros servicios.
                      </p>
                    </section>
                    <section data-id="element-44">
                      <h3 className="text-white font-bold mb-2" data-id="element-45">
                        Protección de Datos
                      </h3>
                      <p data-id="element-46">
                        Implementamos medidas de seguridad para proteger tu
                        información personal. No vendemos, intercambiamos ni
                        transferimos tu información a terceros.
                      </p>
                    </section>
                    <section data-id="element-47">
                      <h3 className="text-white font-bold mb-2" data-id="element-48">Cookies</h3>
                      <p data-id="element-49">
                        Nuestro sitio puede utilizar cookies para mejorar la
                        experiencia del usuario. Puedes configurar tu navegador
                        para rechazar cookies.
                      </p>
                    </section>
                    <section data-id="element-50">
                      <h3 className="text-white font-bold mb-2" data-id="element-51">
                        Cambios en la Política
                      </h3>
                      <p data-id="element-52">
                        Nos reservamos el derecho de actualizar esta política en
                        cualquier momento. Los cambios serán publicados en esta
                        página.
                      </p>
                    </section>
                  </> : <>
                    <section data-id="element-53">
                      <h3 className="text-white font-bold mb-2" data-id="element-54">Servicios</h3>
                      <p data-id="element-55">
                        Ofrecemos servicios de diseño y desarrollo de páginas
                        web (Conversion Landers) para negocios locales. El
                        alcance de cada proyecto se define antes de iniciar el
                        trabajo.
                      </p>
                    </section>
                    <section data-id="element-56">
                      <h3 className="text-white font-bold mb-2" data-id="element-57">Pagos</h3>
                      <p data-id="element-58">
                        El pago de $295 USD es un pago único por el diseño del
                        sitio web. El hosting y mantenimiento tienen un costo
                        adicional de $25/mes. Los pagos no son reembolsables una
                        vez iniciado el proyecto.
                      </p>
                    </section>
                    <section data-id="element-59">
                      <h3 className="text-white font-bold mb-2" data-id="element-60">
                        Propiedad Intelectual
                      </h3>
                      <p data-id="element-61">
                        El diseño final del sitio web es propiedad del cliente
                        una vez completado el pago total. Los elementos de
                        diseño genéricos y plantillas base permanecen como
                        propiedad nuestra.
                      </p>
                    </section>
                    <section data-id="element-62">
                      <h3 className="text-white font-bold mb-2" data-id="element-63">
                        Plazos de Entrega
                      </h3>
                      <p data-id="element-64">
                        Nos comprometemos a entregar tu sitio web en un plazo de
                        7 días hábiles a partir de la recepción de todos los
                        materiales necesarios.
                      </p>
                    </section>
                    <section data-id="element-65">
                      <h3 className="text-white font-bold mb-2" data-id="element-66">
                        Limitación de Responsabilidad
                      </h3>
                      <p data-id="element-67">
                        No somos responsables por pérdidas indirectas derivadas
                        del uso de nuestros servicios. Nuestro sitio web se
                        proporciona tal cual.
                      </p>
                    </section>
                    <section data-id="element-68">
                      <h3 className="text-white font-bold mb-2" data-id="element-69">
                        Modificaciones
                      </h3>
                      <p data-id="element-70">
                        Nos reservamos el derecho de modificar estos términos en
                        cualquier momento. El uso continuado de nuestros
                        servicios constituye la aceptación de los términos
                        actualizados.
                      </p>
                    </section>
                  </>}
              </div>
            </motion.div>
          </div>}
      </AnimatePresence>
    </>;
}